// extracted by mini-css-extract-plugin
export var inputContainer = "_ob-0";